import React from 'react';
import BillingForm from '../Forms/MemberBillingForm/BillingForm';
import CartHeader from '../ShoppingCart/CartHeader';

function MemberBilling({
	setStep,
	defaultValues,
	handleMemberFormSubmission,
	message,
}) {
	return (
		<>
			<CartHeader title='Checkout' />
			<div className='subtitle mb-16 lower roboto'>Add Billing Information</div>
			{message && (
				<div className={`mb-20 alert ${message?.class}`}>{message.message}</div>
			)}
			<BillingForm
				defaultValues={defaultValues}
				setStep={setStep}
				handleMemberFormSubmission={handleMemberFormSubmission}
			/>
		</>
	);
}

export default MemberBilling;
